var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacySecureConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M30 55s20-10 20-25V12.5L30 5l-20 7.5V30c0 15 20 25 20 25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacySecureConnection);
export default __webpack_public_path__ + "static/media/privacy-secure-connection.09932ec05e2741e3bdc101db21d13ada.svg";
export { ForwardRef as ReactComponent };